import PropTypes from 'prop-types';
// material
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
// helpers
import { numberFormat, roundNumber } from '../../../../helpers/Util';

const RootStyle = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2)
}));

TotalAmount.propTypes = {
  transaction: PropTypes.object
};

export default function TotalAmount({ transaction }) {
  return (
    <RootStyle>
      <Box display="flex" alignItems="center" pb={1}>
        <Box flexGrow={1}>
          <Typography variant="body1" component="p" color="textSecondary">
            Subtotal
          </Typography>
          <Typography variant="body1" component="p" color="textSecondary">
            Discount
          </Typography>
          <Typography variant="body1" component="p" color="textSecondary">
            Total
          </Typography>
        </Box>
        <Box>
          <Typography align="right" variant="body1" component="p">
            {numberFormat(transaction.amount.subtotal)}
          </Typography>
          <Typography align="right" variant="body1" component="p">
            -{numberFormat(transaction.amount.discount)}
          </Typography>
          <Typography align="right" variant="body1" component="p">
            {numberFormat(transaction.amount.total)}
          </Typography>
        </Box>
      </Box>
      <Box mb={1}>
        <Typography align="center" variant="body2" component="p" color="textSecondary">
          (Tickets:{numberFormat(roundNumber(transaction.amount.total - transaction.amount.vat))} +
          VAT 23%: {numberFormat(transaction.amount.vat)})
        </Typography>
      </Box>
    </RootStyle>
  );
}
